import { useMemo } from "react";
import { useGetBenefitQuery, useGetBenefitsQuery } from "./benefitEndpoints";
import { Benefit } from "../../entities/benefit";

export function useBenefit(benefitID: number | undefined) {
  const benefitQuery = useGetBenefitQuery(benefitID ?? 0, {
    skip: (benefitID ?? 0) <= 0,
  });
  const benefitEntity = benefitQuery.data;

  return useMemo(() => {
    const ret: typeof benefitQuery & { benefit?: Benefit | undefined } = {
      ...benefitQuery,
    };
    if (benefitEntity) ret.benefit = new Benefit(benefitEntity);
    return ret;
  }, [benefitEntity]);
}

export function useBenefits() {
  const benefitQuery = useGetBenefitsQuery();
  const benefitEntitiesMap = benefitQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof benefitQuery & {
      benefits?: Benefit[];
      benefitsMap?: { [id: number]: Benefit };
    } = {
      ...benefitQuery,
      benefits: [],
      benefitsMap: {},
    };
    if (benefitEntitiesMap) {
      const benefits: Benefit[] = [];
      const benefitsMap: { [id: number]: Benefit } = {};

      for (const key in benefitEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(benefitEntitiesMap, key)) {
          const c = benefitEntitiesMap[key];
          const benefit = new Benefit(c);
          benefits.push(benefit);
          benefitsMap[benefit.id] = benefit;
        }
      }
      ret.benefits = benefits;
      ret.benefitsMap = benefitsMap;
    }

    return ret;
  }, [benefitEntitiesMap]);
}
